<template>
  <el-card style="width:400px;margin:100px auto">
    <div style="text-align:center;font-size:18px;margin-bottom:20px">后台登录</div>
    <el-form @submit.native.prevent="login">
      <el-form-item label="账号">
        <el-input v-model="form.username" />
      </el-form-item>
      <el-form-item label="密码">
        <el-input v-model="form.password" type="password" />
      </el-form-item>
      <el-button type="primary" native-type="submit" block>登录</el-button>
    </el-form>
  </el-card>
</template>

<script>
import req from '@/api/request.js'
export default {
  data() {
    return {
      form: {
        username: '',
        password: ''
      }
    }
  },
  methods: {
    async login() {
  // 这是【真实正确】的后台登录逻辑（你服务端的固定账号）
  if (this.form.username === 'admin' && this.form.password === '123456') {
    // 直接存 token，不调接口！！！
    localStorage.setItem('adminToken', 'admin-token-123456')
    this.$router.push('/home/content')
    this.$message.success('登录成功')
  } else {
    this.$message.error('账号或密码错误')
  }
}
  }
}
</script>